import { render, staticRenderFns } from "./foot-wrap.vue?vue&type=template&id=590fdd7a&scoped=true&"
import script from "./foot-wrap.vue?vue&type=script&lang=js&"
export * from "./foot-wrap.vue?vue&type=script&lang=js&"
import style0 from "./foot-wrap.vue?vue&type=style&index=0&id=590fdd7a&prod&lang=less&"
import style1 from "./foot-wrap.vue?vue&type=style&index=1&id=590fdd7a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590fdd7a",
  null
  
)

export default component.exports